import PropTypes from "prop-types";

export const actionInterfacePropType = PropTypes.shape({
  show: PropTypes.bool,
  isDisabled: PropTypes.func,
  onPress: PropTypes.func,
});

export const actionsPropType = PropTypes.shape({
  editable: PropTypes.oneOfType([
    actionInterfacePropType,
    PropTypes.oneOf([null]),
  ]),
  deletable: PropTypes.oneOfType([
    actionInterfacePropType,
    PropTypes.oneOf([null]),
  ]),
  moreDetail: PropTypes.oneOfType([
    actionInterfacePropType,
    PropTypes.oneOf([null]),
  ]),
  canceled: PropTypes.oneOfType([
    actionInterfacePropType,
    PropTypes.oneOf([null]),
  ]),
  submitPaymentProof: PropTypes.oneOfType([
    actionInterfacePropType,
    PropTypes.oneOf([null]),
  ]),
  approve: PropTypes.oneOfType([
    actionInterfacePropType,
    PropTypes.oneOf([null]),
  ]),
  reject: PropTypes.oneOfType([
    actionInterfacePropType,
    PropTypes.oneOf([null]),
  ]),
  paid: PropTypes.oneOfType([actionInterfacePropType, PropTypes.oneOf([null])]),
});
